import React, { useState } from "react";
import { Dropdown, Menu, Divider, Button, Typography, Tooltip } from "antd";
import colors from "../../share/constants/constants";
import { ReactComponent as DownArrowIcon } from "../../assets/icons/arrowDown.svg";

const Filter = ({ tabs, tabOptions, activeTab, selectedOptions, setActiveTab, handleOptionClick, resetFilters, fetchNewBusinesses }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const { Text } = Typography;

    const handleMenuClick = (tabKey) => {
        if (activeTab === tabKey) {
            setIsDropdownOpen((prev) => !prev); // Toggle dropdown if the same tab is clicked
        } else {
            setActiveTab(tabKey);
            setIsDropdownOpen(true); // Open dropdown for the new tab
        }
    };

    const renderMenuItems = () => {
        const options = tabOptions[activeTab] || [];
        const currentSelectedOptions = selectedOptions[activeTab] || [];
        const tabTitle = activeTab === "Staff Size" ? "Staff Size" : activeTab === "Business Type" ? "Business Type" : activeTab;

        return (
            <div className="p-2 bg-white rounded-lg shadow-lg w-48 relative dropdown-container mt-1">
                <div className="mb-2">
                    <Text strong style={{ fontSize: 18 }}>{tabTitle}</Text>
                </div>
                <div
                    className="grid grid-cols-3 gap-2 mb-2"
                    style={{
                        maxHeight: "250px",
                        overflowY: "auto",
                    }}
                >
                    {options?.map((option) => {
                        const id = option._id || option;
                        const name = option.name || option;
                        return (
                            <Button
                                key={id}
                                onClick={() => handleOptionClick(option)}
                                className="col-span-1 text-center rounded-2xl h-auto w-14 py-0.5"
                                style={{
                                    width: "100%",
                                    background: currentSelectedOptions.includes(id)
                                        ? colors.primaryPurple
                                        : "",
                                    color: currentSelectedOptions.includes(id) ? colors.white : "",
                                }}
                            >
                                <Tooltip title={name}>
                                    <Text ellipsis style={{ maxWidth: 80, color: currentSelectedOptions.includes(id) ? colors.white : "", }}>{name}</Text>
                                </Tooltip>
                            </Button>
                        );
                    })}
                </div>
                <Divider />
                <div className="flex justify-between items-center">
                    <Text className="text-grey text-sm">
                        *You can choose {activeTab === "Business Type" ? "multiple options" : "one option"}
                    </Text>
                    <Button className="w-13 h-auto rounded-sm bg-primaryPurple text-white py-0.5 hover:text-white custom-button" onClick={() => {
                        fetchNewBusinesses(selectedOptions);
                        setIsDropdownOpen(false);
                    }}>
                        Apply Now
                    </Button>
                </div>
            </div>
        );
    };

    return (
        <div className="flex justify-around bg-gray-100 mt-2 ml-2 h-6 w-[75%] bg-white px-1 rounded-2xl">
            {tabs?.map((tab, index) =>
                index > 1 && index < tabs.length - 1 ? (
                    <Dropdown
                        overlay={renderMenuItems}
                        trigger={["click"]}
                        key={tab.key}
                        placement={"bottom"}
                        open={isDropdownOpen && activeTab === tab.key}
                    >
                        <div
                            onClick={() => handleMenuClick(tab.key)}
                            className={`cursor-pointer py-1 flex items-center justify-between pl-2.4 ${activeTab === tab.key
                                ? "bg-white text-black"
                                : "bg-white text-black"
                                } ${index < tabs.length - 1 ? "border-r-2 border-red-300" : ""
                                }`}
                            style={{
                                borderRight: `${index < tabs.length - 1
                                    ? `1px solid ${colors.primaryColor}`
                                    : ""
                                    }`,
                            }}
                        >
                            {tab.label}{" "}
                            <div
                                className="flex items-center pl-2 pr-2.4 transition-transform duration-300"
                                style={{
                                    transform:
                                        activeTab === tab.key && isDropdownOpen
                                            ? "rotate(-180deg)"
                                            : "rotate(0deg)",
                                }}
                            >
                                <DownArrowIcon />
                            </div>
                        </div>
                    </Dropdown>
                ) : index === tabs.length - 1 ? (
                    <div
                        key={tab.key}
                        onClick={() => resetFilters(setIsDropdownOpen)}
                        className={`cursor-pointer py-1 flex items-center justify-between pl-2.4 bg-white text-black px-2`}
                    >
                        {tab.label}
                    </div>
                ) : (
                    <div
                        key={tab.key}
                        onClick={() => handleMenuClick(tab.key)}
                        className={`py-1 flex items-center justify-between pl-2.4 ${activeTab === tab.key
                            ? "bg-white text-black"
                            : "bg-white text-black"
                            } ${index < tabs.length - 1 ? "border-r-2 border-red-300" : ""
                            } px-2`}
                        style={{
                            borderRight: `${index < tabs.length - 1
                                ? `1px solid ${colors.primaryColor}`
                                : ""
                                }`,
                        }}
                    >
                        {tab.label}
                    </div>
                )
            )}
        </div>
    );
};

export default Filter;
